import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const displayScreenUrls = {
  displayScreens: `${baseURL}/displays`
};

export default displayScreenUrls;
